import { z } from 'zod';

/** Source of truth for app + migration CHECK on site_intent_suggestions.kind */
export const INTENT_SUGGESTION_KINDS = ['question', 'topic', 'completion', 'operator'] as const;
export type IntentSuggestionKind = (typeof INTENT_SUGGESTION_KINDS)[number];

export const SITE_INTENT_ASSIST_CONFIG_TABLE = 'site_intent_assist_config' as const;
export const SITE_INTENT_SUGGESTIONS_TABLE = 'site_intent_suggestions' as const;

export const INTENT_REBUILD_STATUSES = [
  'idle',
  'queued',
  'running',
  'cancelling',
  'failed',
] as const;
export type IntentRebuildStatus = (typeof INTENT_REBUILD_STATUSES)[number];

export const intentSuggestionKindSchema = z.enum(INTENT_SUGGESTION_KINDS);
export const intentRebuildStatusSchema = z.enum(INTENT_REBUILD_STATUSES);

export const intentAssistConfigFormSchema = z.object({
  enabled: z.boolean(),
  rebuildAfterCrawl: z.boolean(),
});
export type IntentAssistConfigFormData = z.infer<typeof intentAssistConfigFormSchema>;

export const intentSuggestRequestSchema = z.object({
  tenant_id: z.string().uuid(),
  site_id: z.string().uuid(),
  partial: z.string().max(500),
  page_url: z.string().url().optional().or(z.literal('')),
  session_id: z.string().max(128).optional(),
});
export type IntentSuggestRequest = z.infer<typeof intentSuggestRequestSchema>;

export const intentSuggestionDtoSchema = z.object({
  id: z.string(),
  kind: intentSuggestionKindSchema,
  label: z.string(),
  insertText: z.string(),
  sourceUrl: z.string().nullable().optional(),
});
export type IntentSuggestionDto = z.infer<typeof intentSuggestionDtoSchema>;

export const intentSuggestResponseSchema = z.object({
  suggestions: z.array(intentSuggestionDtoSchema),
});

export const intentRebuildJobPayloadSchema = z.object({
  tenantId: z.string().uuid(),
  siteId: z.string().uuid(),
  requestId: z.string().min(1).max(128),
});
export type IntentRebuildJobPayload = z.infer<typeof intentRebuildJobPayloadSchema>;

/** MVP accept mode — human testing may flip to auto_send later. */
export const INTENT_SUGGESTION_ACCEPT_MODE = 'fill' as const;
export type IntentSuggestionAcceptMode = 'fill' | 'auto_send';

export type IntentAssistStatusPayload = {
  rebuildStatus: IntentRebuildStatus;
  rebuildProgressPagesDone: number;
  rebuildProgressPagesTotal: number;
  lastRebuildCompletedAt: string | null;
  lastRebuildSuggestionCount: number | null;
  lastRebuildPageCount: number | null;
  lastRebuildError: string | null;
  catalogMayBeStale: boolean;
};

export const DEFAULT_INTENT_ASSIST_STATUS: IntentAssistStatusPayload = {
  rebuildStatus: 'idle',
  rebuildProgressPagesDone: 0,
  rebuildProgressPagesTotal: 0,
  lastRebuildCompletedAt: null,
  lastRebuildSuggestionCount: null,
  lastRebuildPageCount: null,
  lastRebuildError: null,
  catalogMayBeStale: false,
};
